import axiosConfig from "./axiosConfig";

const getWarm = async (authToken: string, page: string): Promise<void> => {
  await axiosConfig.get("/warm", {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    params: { page },
  });
};

export default getWarm;
